<template>
	<div id="quick">
		<div class="quick_main">
			<div class="title">尚未确认之提现(极速提现)</div>
			<div class="content">
				<el-radio-group style="display: flex; flex-direction: column" v-model="radio">
					<template v-for="(item, index) in unComfirmedList">
						<el-radio :key="index" :label="item.OrderNumber">{{ `[${item.ApplyTime}] ${item.DmMoney}` }}</el-radio>
					</template>
				</el-radio-group>
				<el-button :loading="isLoading" size="small" @click="submitConfirm(radio)">确认已到帐</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { postAjax } from "../../util/ajax.js";
import { getUserInfo } from "../../util/getdata";

export default {
	data() {
		return {
			radio: null,
			unComfirmedList: [],
			isLoading: false,
		};
	},
	methods: {
		init() {
			const that = this;
			const url = "Api/Cash/GetQuickUnconfirmed";
			postAjax(url)
				.then(r => {
					if (r.IsSucess) {
						that.unComfirmedList = r.Data;
					} else {
						that.$message.error(r.Message);
					}
				})
				.catch(() => {
					that.$message.error("网络异常，请刷新后在试");
				});
		},
		submitConfirm(payload = "") {
			const that = this;
			if (!this.radio) return that.$message.info("请选择未确认之提现");
			const url = "Api/Cash/SetQuickConfirm";
			that.isLoading = true;
			postAjax(url, { OrderNumber: payload })
				.then(r => {
					if (r.IsSucess) {
						that.$message.success(r.Message);
						that.init();
						that.radio = null;
						getUserInfo();
					} else {
						that.$message.error(r.Message);
					}
				})
				.catch(() => {
					that.$message.error("网络异常，请刷新后在试");
				})
				.finally(() => {
					that.isLoading = false;
				});
		},
	},
	mounted() {
		this.init();
	},
};
</script>

<style lang="scss" scoped>
#quick {
	height: 100%;

	.quick_main {
		width: 750px;
		margin: auto;
		margin-top: 50px;
		padding: 10px 30px 20px 30px;
		box-shadow: 0px 2px 16px 0px rgba(53, 63, 75, 0.1);
		border-radius: 5px;

		.title {
			font-size: 20px;
			margin: 20px;
		}
		.content {
			.el-radio {
				margin: 10px 20px;
			}
			.el-button {
				margin: 20px;
				background-color: transparent;
				color: #0e78c7;
				border-color: #0e78c7;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/AccountCenter/Quick.vue